// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"629":"299076d5a2c86058","888":"d1fcd443590c55fe"}[chunkId] + ".css";
};